import type { ExperimentResDto } from './dto/response/experiment.res.dto';
import type { GateResDto } from './dto/response/gate.res.dto';

/**
 * Statsig API 클래스
 * Next.js API Route를 통해 Statsig 콘솔 API를 프록시 호출
 */
export class StatsigApi {
  private static readonly BASE = '/api/statsig';

  static readonly queryKeys = {
    activeExperiments: () => [`${StatsigApi.BASE}/experiments`],
    activeGates: () => [`${StatsigApi.BASE}/gates`],
  };

  /**
   * 활성 실험 목록 조회
   */
  static async findActiveExperiments(): Promise<ExperimentResDto[]> {
    const res = await fetch(`${StatsigApi.BASE}/experiments`);
    const data = await res.json();
    return data.experiments ?? [];
  }

  /**
   * gate(feature flag) 목록 조회 — 활성/비활성 모두 포함
   */
  static async findGates(): Promise<GateResDto[]> {
    const res = await fetch(`${StatsigApi.BASE}/gates`);
    const data = await res.json();
    return data.gates ?? [];
  }
}
